import { useEffect, useState } from "react";
import { ArrowUpRight, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SITE_NAVIGATION } from "@/lib/navigation";

const chipClass = "nav-chip font-mono-label text-[10px] tracking-normal uppercase whitespace-nowrap inline-flex items-center gap-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0F141B]";

export const DesktopNavigation = () => {
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 1280px)");
    const onResize = () => { if (!desktop.matches) setOpenMenu(null); };
    desktop.addEventListener("change", onResize);
    return () => desktop.removeEventListener("change", onResize);
  }, []);

  return (
    <nav data-testid="primary-nav" aria-label="Main navigation" className="hidden xl:flex min-w-0 flex-1 items-center justify-end gap-1.5">
      {SITE_NAVIGATION.map((group) => group.items ? (
        <DropdownMenu key={group.id} modal={false} open={openMenu === group.id} onOpenChange={(open) => setOpenMenu(open ? group.id : null)}>
          <DropdownMenuTrigger asChild>
            <button type="button" data-testid={`nav-dropdown-${group.id}`} className={`${chipClass} data-[state=open]:bg-[#F0F2F4]`}>
              {group.label}
              <ChevronDown size={12} aria-hidden="true" className={`transition-transform duration-200 ${openMenu === group.id ? "rotate-180" : ""}`} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent data-testid={`nav-menu-${group.id}`} align="start" sideOffset={12} collisionPadding={16} className="z-[60] w-[232px] rounded-none border-[#D2D5DA] bg-white p-1.5 shadow-[0_18px_40px_rgba(15,17,23,0.12)]">
            {group.items.map((item) => (
              <DropdownMenuItem key={item.id} asChild className="rounded-none px-3 py-3 text-sm font-semibold text-[#0F1117] focus:bg-[#F4F5F7] focus:text-[#0F1117] cursor-pointer">
                <a href={item.href} data-testid={`nav-link-${item.id}`} className="flex items-center justify-between gap-4">
                  {item.label}
                  <ArrowUpRight size={14} aria-hidden="true" className="text-[#8A94A2]" />
                </a>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <a key={group.id} href={group.href} data-testid={`nav-link-${group.id}`} className={chipClass}>{group.wordmark ? <><span aria-hidden="true" className="academy-node !w-[5px] !h-[5px]" /><span data-testid="nav-academy-wordmark" className="font-orbitron font-black text-[11.5px] leading-[15px] normal-case text-[#160907]">{group.label}</span>{group.soon && <span data-testid="nav-academy-soon-tag" className="academy-soon-tag">Soon</span>}</> : group.label}</a>
      ))}
    </nav>
  );
};